import React, { useCallback, useState, useEffect } from 'react';
import styles from './templates.module.scss';
import PhoneInput from "antd-phone-input";
import { Checkbox, KoAvatar, KoButton, KoDate, KoDropdown, KoForm, KoFormBuilder, KoModal, KoNano, KoRadio, KoRichTextEditor, KoRichTextEditorReadOnly, KoSearch, KoSelect, KoText, KoTimePicker, KoTitle, KoToast } from 'packages';
import KoIcon from '@kwapio/icons';
import { ClientsAPI } from '../customers.service';
import { toHtml } from 'packages/richText/utils/exportUtils';
import SlateEditorWithPreview from 'packages/richText/slatePreview';
export default function MessageTemplates() {
  const [form] = KoForm.useForm();
  const [sendForm] = KoForm.useForm();
  const [currentTemplate, setCurrentTemplate] = useState();
  const [isTemplateOpen, setTemplateModal] = useState(false);
  const [isLoading, setLoading ] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [sendMessageModal, setSendMessageModal] = useState(false);
  const [templateList, setTemplateList ] = useState([]);
  const [rowList, setDataList] = useState();
  const messageType = KoForm.useWatch('messageType', form);
  const scheduleType = KoForm.useWatch('schedule', form);
  const [sendMessageModalPreview, setSendMessageModalPreview] = useState(false);

  useEffect(() => {
    getClients();
    getTemplates();
  }, []);

  const generateHtmlFile = (htmlContent, title = "Document") => `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${title}</title>
<style>
  body { font-family: Arial, sans-serif; line-height: 1.5; padding: 1rem; }
  .slate-bold { font-weight: bold; }
  .slate-italic { font-style: italic; }
  .slate-underline { text-decoration: underline; }
  .slate-strike { text-decoration: line-through; }
  .slate-code { font-family: monospace; background: #f5f5f5; padding: 2px 4px; border-radius: 3px; }
  .slate-highlight { background-color: yellow; }
  .slate-link { color: #1890ff; text-decoration: underline; }
  .slate-paragraph { margin: 0.5rem 0; }
  .slate-h1 { font-size: 2em; margin: 1rem 0; }
  .slate-h2 { font-size: 1.75em; margin: 0.9rem 0; }
  .slate-h3 { font-size: 1.5em; margin: 0.8rem 0; }
  .slate-h4 { font-size: 1.25em; margin: 0.7rem 0; }
  .slate-h5 { font-size: 1em; margin: 0.6rem 0; }
  .slate-h6 { font-size: 0.875em; margin: 0.5rem 0; }
  .slate-block-quote { border-left: 4px solid #ccc; margin: 0.3rem 0; padding: 0.1rem 0.5rem; color: #666; font-style: italic; }
  .slate-ul, .slate-ol { margin: 0.5rem 0 0.5rem 1.5rem; }
  .slate-li { margin: 0.25rem 0; }
  .slate-code-block { background: #f5f5f5; padding: 0.5rem; border-radius: 4px; overflow-x: auto; }
  .slate-check-list-item { display: flex; align-items: center; margin: 0.25rem 0; }
  .slate-check-list-item input[type="checkbox"] { margin-right: 0.5rem; }
  .slate-image { max-width: 100%; height: auto; display: block; margin: 0.5rem 0; }
  .slate-video { max-width: 100%; margin: 0.5rem 0; }
</style>
</head>
<body>
${htmlContent}
</body>
</html>
`;

  const handleSubmit = useCallback(values => {
    values['contentString'] = JSON.stringify(generateHtmlFile(toHtml(values.content)));
    if(!currentTemplate?.templateId){
      values['templateId'] = KoNano('tmp');
    }
    if(!scheduleType){
      values['sentTo'] = null;
      values['startDate'] = null;
      values['endDate'] = null;
      values['sendTime'] = null;
      values['recurrence'] = null;
    }

    setLoading(true);
    ClientsAPI.createOrUpdateTemplate(values, currentTemplate?.templateId).then(
      (data) => {
        getTemplates();
        setLoading(false);
        form.resetFields();
        setCurrentTemplate(null);
        setTemplateModal(false);
        KoToast.success(!values.templateId ? 'Template created successfully' : 'Updated successfully');
      },
      (err) => {
        setLoading(false);
      }
    );
  });

  const handleSendSubmit = useCallback(values => {
    setLoading(true);
    let data = {
      ...values,
      templateId: currentTemplate?.templateId
    };
    ClientsAPI.sendEmial(data).then(
      (data) => {
        setLoading(false);
        setSendMessageModal(false);
        sendForm.resetFields();
        KoToast.success('Notification sent successfully');
      },
      (err) => {
        setLoading(false);
      }
    );
  });


  const getClients = (pagination) => {
    setLoading(true);
    ClientsAPI.getClients(pagination).then(
      (data) => {
        setDataList();
        setDataList(data['customers']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getTemplates = (pagination) => {
    setLoading(true);
    ClientsAPI.getTemplates(pagination).then(
      (data) => {
        setTemplateList();
        setTemplateList(data['templates']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const enabledButtons = {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    blockquote: true,
    numberedList: true,
    unorderedList: true,
    codeBlock: true,
    link: true
  };

  const AcceptanceCriteria = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons} value={value} initialValues={value}
      form={form} name='acceptanceCriteria'
      onSetEditorValues={v => onChange(v)}
    />;


  const ActivityType = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder="Select Message type"
      options={[
        {
          label: 'Email',
          value: 'email',
          icon: 'EmailOutlined'
        },
        {
          label: 'SMS',
          value: 'sms',
          icon: 'MessageOutlined'
        },
        {
          label: 'WhatsApp',
          value: 'whatsapp',
          icon: 'WhatsAppOutlined'
        }
      ]}
      optionRender={(option) => (
        <div className={styles.iconWithLabel} role="img" aria-label={option.data?.label}>
          <KoIcon name={option.data?.icon} />
          {option.data?.label}
        </div>
      )}
    />
  );

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };


  const Time = ({ value, onChange }) => {
    const handleChange = (v) => {
      const formattedValue = v instanceof Date ? v.toTimeString().slice(0, 5) : v;
      onChange(formattedValue);
    };

    const formattedValue = value ? (value instanceof Date ? value.toTimeString().slice(0, 5) : value) : '';

    return (
      <KoTimePicker
        changeOnScroll
        needConfirm={false}
        allowClear={false}
        value={formattedValue}
        format='HH:mm'
        onChange={handleChange}
      />
    );
  };

  const RecurrenceValues = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekdays Only (Mon–Fri)', value: 'weekday' },
    { label: 'Weekly (Same Day)', value: 'weekly' },
    { label: 'Weekends Only (Sat–Sun)', value: 'weekends' },
    { label: 'Monthly (Same Date)', value: 'monthly' }
  ];
  
  const Recurrence = ({ value, onChange }) =>
  
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose recurrence'
      options={RecurrenceValues?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;





  const Email = ({ value, onChange }) => (
    <KoSelect mode="tags" tokenSeparators={[',']} value={value} onChange={onChange} placeholder={messageType === 'email' ? 'Enter Email' : 'Enter Mobile'} />
  );

  const EmailOptions =  ({ value, onChange }) => (
    <KoRadio defaultValue={'all'} onChange={onChange} value={value} direction="horizontal"  options={[
      { label: 'All Customers', value: 'all' },
      { label: 'Selected Customers', value: 'specific' }
    ]} />
  );

  const Assignees = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      mode="multiple"
      placeholder="Select Customers"
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      optionRender={(option) => (
        <div className="userDpWithName">
          <KoAvatar
            inLine="0rem"
            size={30}
            options={[{ name: option.data.label, logo: option?.data.emoji }]}
          />
          <div className="userDpWithNameEmail">
            <KoText className="name" text={`${option.data.label} (${option.data.email})`} />
            <PhoneInput
              className="mobileNo"
              disableDropdown
              readOnly
              value={option?.data?.mobile}
            />
          </div>
        </div>
      )}
      options={
        (rowList || []).map((user) => ({
          label: `${user?.firstName || user?.email} ${user?.lastName || ''}`,
          value: user?.customerId || '',
          mobile: user?.mobile || '',
          email: user?.email || '',
          data: {
            label: `${user?.firstName || user?.email} ${user?.lastName || ''}`,
            emoji: user?.logo || '',
            email: user?.email || '',
            mobile: user?.mobile || ''
          }
        }))
      }
    />
  );



  const sendMeta = {
    columns: 4,
    formItemLayout: null,
    initialValues: currentTemplate,
    colon: true,
    fields: [
      {
        key: 'sendTo', label: 'Send To', colSpan: 4,
        widget: EmailOptions
      },
      { key: 'selectedCustomers', label: 'Customers', colSpan: 4, widget: Assignees },
      { key: 'customEmail', label: messageType === 'email' ? 'Email' : 'Mobile', colSpan: 4, widget: Email }
     
    ]
  };


  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: currentTemplate,
    colon: true,
    fields: [
      {
        key: 'name', label: 'Name', colSpan: 2,
        rules: [
          {
            required: true,
            message: `Please select Template name.`
          }
        ]
      },
      {
        key: 'messageType', label: 'Message Type', colSpan: 2,
        widget: ActivityType,
        rules: [
          {
            required: true,
            message: `Please select Message Type.`
          }
        ]
      },
      {
        key: 'subject', label: 'Subject', colSpan: 4,
        rules: [
          {
            required: true,
            message: `Please select Subject.`
          }
        ]
      },
      {
        key: 'content', label: 'Content', colSpan: 4,  widget: AcceptanceCriteria,
        rules: [
          {
            required: true,
            message: `Please select Content.`
          }
        ]
      },
     
      { key: 'schedule', colSpan: 4, label: 'SCHEDULE', widget: Checkbox }
      
     
    ]
  };

  if(scheduleType){
    let extra=[ { key: 'startDate', label: 'Start Date', colSpan: 2, widget: Date },
      { key: 'endDate', label: 'End Date', colSpan: 2, widget: Date },
      { key: 'sendTime', label: 'Time', colSpan: 2, widget: Time },
      { key: 'recurrence', label: 'Recurrence', colSpan: 2, widget: Recurrence },
      ...sendMeta.fields];
    meta.fields.push(...extra);
  }
  




 
 

  const deleteTemplate = (templateId) => {
    setLoading(true);
    ClientsAPI.deleteTemplate(templateId).then(
      (data) => {
        setLoading(false);
        getTemplates();
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <KoTitle text={'Message Templates'} level={4} />
        <div className={styles.actions}>
          <KoSearch placeholder='Search by name' />
          <KoButton type='primary' icon={<KoIcon name='PlusOutlined' color='#FFF' />} label={'New Template'} onClick={() => {form.resetFields(); setTemplateModal(true);}} />
        </div>
      </div>
      <div className={styles.emailTemplates} onClick={() => dropdownVisible && setDropdownVisible(false)}>
        {templateList.map((item, index) => (
          <div className={styles.emailTemplate} key={index}>
            <div className={styles.messageType}>
              {item.messageType.includes('email')&& <KoIcon name={'EmailOutlined'} width={20} height={20} color={'#EA4335'} />}
              {item.messageType.includes('sms') && <KoIcon name={'MessageOutlined'} width={23} height={23} color={'#0995FF'} />}
              {item.messageType.includes('whatsapp') && <KoIcon name={'WhatsAppOutlined'} width={23} height={23} color={'#25D366'} />}
              <KoTitle text={item.name} level={5} />
            </div>
            <div className={styles.subject}>
              <div className={styles.subjectWrapper}>
                <KoText text={'Subject'} className={styles.label} />
                <KoText text={`${item.subject || 'no subject'}`} className={styles.subjectText} />
              </div>
              <div className={styles.subjectWrapper}>
                <KoText text={'Body'} className={styles.label} />
                <KoRichTextEditorReadOnly text='no body' initialValues={item.content} />
              </div>
            </div>
            <KoDropdown
              trigger={['click']}
              open={dropdownVisible && currentTemplate?.templateId === item?.templateId}
              popupRender={(menu) => (
                <div className={styles.customDropdown} >
                  <div className={styles.customDropdownContnet}>
                    <ul>
                      <li onClick={() => {setDropdownVisible(false); setCurrentTemplate(item);setTemplateModal(true);}}>
                        <KoIcon name={'EditOutlined'} />
                        <KoText text={'Edit'} />
                      </li>
                      <li onClick={() => {setDropdownVisible(false); setCurrentTemplate(item);setSendMessageModal(true);}}>
                        <KoIcon name={'SendOutlined'} color={'#FF0000'} />
                        <KoText text={'Send'} />
                      </li>
                      <li onClick={() => {setDropdownVisible(false); setCurrentTemplate(item);setSendMessageModalPreview(true);}}>
                        <KoIcon name={'OpenOutlined'}/>
                        <KoText text={'Perview'} />
                      </li>
                      <li onClick={() => {setDropdownVisible(false); setCurrentTemplate(item);deleteTemplate(item?.templateId);}}>
                        <KoIcon name={'DeleteOutlined'} color={'#FF0000'} />
                        <KoText text={'Delete'} />
                      </li>

                    </ul>
                  </div>
                </div>
              )}
              placement={'bottomRight'}>
              <KoButton onClick={() => { setCurrentTemplate(item);setDropdownVisible(true);}} type='text' icon={<KoIcon name="VerticalMenuOutlined" width={18} height={18} />} className={`${styles.settings} smallBtn`} />
            </KoDropdown>

          </div>
        ))}
        {/* <SlateEditorWithPreview /> */}
      </div>
      <KoModal
        title={currentTemplate?.templateId ? `Update Template ${currentTemplate?.name?.toUpperCase()}` : 'Create Template'}
        centered
        open={isTemplateOpen}
        afterClose={() => { form.resetFields(); setTemplateModal(); }}
        handleOk={() => { form.resetFields(); setTemplateModal();}}
        onClose={() => { form.resetFields(); setTemplateModal();}}
        width={800}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setTemplateModal(false); form.resetFields(); }} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`${currentTemplate?.templateId ? 'Update' : 'Create'}`} onClick={() => form.submit()} />
        ]}
      >
        <div className={styles.modalContent}>
          <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
            <KoFormBuilder form={form} meta={meta} />
          </KoForm>
        </div>
      </KoModal>
      <KoModal
        title={`Send ${currentTemplate?.messageType}`}
        centered
        open={sendMessageModal}
        afterClose={() => { sendForm.resetFields(); setSendMessageModal(); }}
        handleOk={() => { sendForm.resetFields(); setSendMessageModal();}}
        onClose={() => { sendForm.resetFields(); setSendMessageModal();}}
        width={750}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setSendMessageModal(false); sendForm.resetFields(); }} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`${currentTemplate?.folderId ? 'Send' : 'Send'}`} onClick={() => sendForm.submit()} />
        ]}
      >
        <div className={styles.modalContent}>
          <KoForm form={sendForm} layout="vertical" onFinish={handleSendSubmit} onSubmit={handleSendSubmit}>
            <KoFormBuilder form={sendForm} meta={sendMeta} />
          </KoForm>
        </div>
      </KoModal>
      <KoModal
        title={`${currentTemplate?.name} Preview`}
        centered
        open={sendMessageModalPreview}
        afterClose={() => { sendForm.resetFields(); setSendMessageModalPreview(); }}
        handleOk={() => { sendForm.resetFields(); setSendMessageModalPreview();}}
        onClose={() => { sendForm.resetFields(); setSendMessageModalPreview();}}
        width={750}
        footer={[
          <KoButton key='cancel' label='Close' onClick={() => { setSendMessageModalPreview(false); sendForm.resetFields(); }} />
        ]}
      >
        <div className={styles.modalContent}>
          <SlateEditorWithPreview value={currentTemplate?.content} />
        </div>
      </KoModal>
    </div>
  );
}
